import { render, staticRenderFns } from "./infoIndex.vue?vue&type=template&id=6482c52e"
import script from "./infoIndex.vue?vue&type=script&lang=ts"
export * from "./infoIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports